<template>
  <div class="app">
    <div class="background" :style="backgroundStyle">
      <div class="button-container" v-if="configLoaded">
        <div
          v-for="(button, index) in buttons"
          :key="index"
          class="button"
          @click="openUrl(button.url)"
        >
          <button class="customer-service-button">
            {{ button.name }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bgImage from './assets/bg.png';

export default {
  data() {
    return {
      buttons: [],
      configLoaded: false,
    };
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      };
    },
  },
  methods: {
    // 获取URL参数
    getUrlParam(name) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name);
    },
    // 获取配置文件路径
    getConfigPath() {
      const clubId = this.getUrlParam('club') || '16888'; // 默认使用16888
      return `/config-${clubId}.json`;
    },
    // 加载配置文件
    async fetchConfig() {
      const timestamp = new Date().getTime(); // 确保获取最新的config.json
      const configPath = this.getConfigPath();
      const defaultConfigPath = '/config-16888.json'; // 默认配置路径
      
      try {
        // 尝试加载指定联盟的配置
        let response = await fetch(`${configPath}?${timestamp}`);
        
        // 如果配置文件不存在（404），则加载默认配置
        if (!response.ok) {
          console.warn(`配置文件 ${configPath} 不存在，使用默认配置`);
          response = await fetch(`${defaultConfigPath}?${timestamp}`);
        }
        
        const configData = await response.json();
        
        if (Array.isArray(configData.app) && configData.app.length > 0) {
          // 生成按钮
          this.buttons = configData.app.map((url, index) => ({
            name: `在线客服 ${index + 1}`,
            url,
            isShow: true,
          }));
          this.configLoaded = true;
        } else {
          throw new Error('配置数据格式错误');
        }
      } catch (error) {
        console.error('加载配置失败:', error);
        // 如果所有尝试都失败，尝试最后一次加载默认配置
        try {
          const response = await fetch(`${defaultConfigPath}?${timestamp}`);
          const configData = await response.json();
          if (Array.isArray(configData.app) && configData.app.length > 0) {
            this.buttons = configData.app.map((url, index) => ({
              name: `在线客服 ${index + 1}`,
              url,
              isShow: true,
            }));
            this.configLoaded = true;
          }
        } catch (fallbackError) {
          console.error('加载默认配置也失败:', fallbackError);
          this.configLoaded = false;
        }
      }
    },
    openUrl(url) {
      if (url) {
        window.location.href = url;
      } else {
        alert('请刷新页面后重试');
        this.fetchConfig();
      }
    },
  },
  mounted() {
    this.fetchConfig();
    document.body.style.margin = '0';
    document.documentElement.style.margin = '0';
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.app {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
}
.background {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.button-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
  max-width: 400px;
  position: absolute;
  bottom: 100px;
  padding: 0 20px;
}
.button {
  display: flex;
  justify-content: center;
}
.customer-service-button {
  width: 100%;
  max-width: 180px;
  padding: 12px 24px;
  background: linear-gradient(180deg, #8F743B 0%, #F9D899 50%, #8F743B 100%); /* Gradient from darker gold to light gold/cream */
  border: 2px solid #1a4732; /* Dark green border */
  color: #4A2F0A; /* Deep brown text for better pairing */
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  border-radius: 8px; /* Rounded corners */
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background 0.3s ease, transform 0.1s ease;
}
.customer-service-button:hover {
  background: linear-gradient(180deg, #6F5C2E 0%, #E6C57A 50%, #6F5C2E 100%); /* Darker gradient on hover */
}
.customer-service-button:active {
  transform: scale(0.95); /* Scale down on click for dynamic effect */
}
@media screen and (min-width: 768px) {
  .app {
    max-width: 480px;
    height: 100vh;
    border: 1px solid #ccc;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .button-container {
    grid-template-columns: repeat(2, 1fr);
    max-width: 480px;
  }
}
</style>